export default __webpack_public_path__ + "static/media/marker-base.059c0ef7.svg";